// extracted by mini-css-extract-plugin
export default {"alignRight":"alignRight__NGY3N","alignCenter":"alignCenter__NGVhO"};